import adminPaymentsListComponent from './admin-payments-list.component';

const adminPaymentsListModule = angular.module('adminPaymentsList', [
])
  .component('adminPaymentsList', adminPaymentsListComponent)
  .name;

export default adminPaymentsListModule;
